import React, { useEffect } from "react";
import Sidebar from "./Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";

const Setting = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("clientToken")) {
      navigate("/client/login");
    }
  }, []);

  return (
    <div className="pro-app-page pro-app-page--muted client-settings-page">
      <div className="custom_container d-flex">
        <Sidebar />
      </div>
    </div>
  );
};

export default Setting;
